import { createReducer } from '@reduxjs/toolkit';
import { lastViewedTabUpdated, NavId } from '../thunks/navigation.thunks';

type NavigationState = {
  lastVisitedTab: {
    [id in NavId]: string;
  };
};

const initialState: NavigationState = {
  lastVisitedTab: {
    browse: '',
    flows: '',
    model: '',
    'data-type': '',
    dataset: '',
    datasets: '',
    pipe: '',
    pipes: '',
    'settings-datahub': '',
    'settings-subscription': '',
    system: '',
    systems: '',
  },
};

/*
Note: We are using the builder callback for creating a typesafe reducer.
See https://redux-toolkit.js.org/usage/usage-with-typescript#building-type-safe-reducer-argument-objects
*/
export const navigationReducer = createReducer(initialState, (builder) =>
  builder.addCase(lastViewedTabUpdated, (state, action) => {
    state.lastVisitedTab[action.payload.navId] = action.payload.value;
  })
);
